module.exports = __webpack_public_path__ + "img/bg.2ed39379.png";